<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Shareholder Meeting',
          to: {
            name: 'ShareholderMeeting'
          }
        },
        { name: 'Edit',
          to: {
            name: 'ShareholderMeetingEdit',
            params: {
              id: $route.params.id,
            }
          },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯Shareholder Meeting</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!--  -->
    <ShareholderMeetingCreateEdit></ShareholderMeetingCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ShareholderMeetingCreateEdit from '@/views/I-3__IR-ShareholderMeeting/c/ShareholderMeetingCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    ShareholderMeetingCreateEdit,
  },
  async created() {
    if (this.$route.params.id) {
      await this.getShareholderMeeting(this.$route.params.id);
    }
  },
  computed: {
    ...mapState('shareholderMeeting', ['shareholderMeeting']),
  },
  methods: {
    ...mapActions('shareholderMeeting', {
      getShareholderMeeting: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'ShareholderMeeting' });
    },
    saveHandler() {
      this.save(this.shareholderMeeting).then(() => {
        this.$router.push({ name: 'ShareholderMeeting' });
      });
    },
  },
};
</script>

<style></style>
